// 自定义国际化配置
import { createI18n } from 'vue-i18n';
import store from '@/store/index';

// 本地语言包
import EN from './lang/en.json';
import zhHK from './lang/zh-HK.json';
import zhCN from './lang/zh-CN.json';

const messages = {
  'zh-hk': {
    ...zhHK,
  },
  en: {
    ...EN,
  },
  'zh-cn': {
    ...zhCN,
  },
};

/**
 * 获取当前系统使用语言字符串
 *
 * @returns zh-cn|en ...
 */
export const getLanguage = () => {
  // 本地缓存获取
  let language = store.getters.getLanguageValue;
  if (language) {
    return language;
  }
  // 浏览器使用语言
  language = navigator.language.toLowerCase();
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale;
    }
  }
  return 'zh-hk';
};

const i18n = createI18n({
  legacy: false,
  locale: getLanguage(),
  globalInjection: true,
  messages: messages,
});

export default i18n;
